import CheckoutProvider from './Checkout.provider';

export default CheckoutProvider;
